import Modal from '@Components/Shared/Modals/Modal';
import translator from '@Components/Utilities/Translator';
import React, { useState, useEffect, useRef } from 'react';
import { useWindowSize } from '@Components/Utilities/WindowSize';
import { setLocalStorageValue } from '@Components/Utilities/CookieHelper';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';
import { LoginPromptEvents } from '@Components/Utilities/SandhillsConstants';
import { getURLParameter } from '@Components/Utilities/SandhillsUtility';

const SignInForBestExperienceModal = (props) => {

    const currentSite = useRecoilValue(atoms.currentWebsite);
    const routes = useRecoilValue(atoms.routes);
    const modalRef = useRef(null);
    const windowSize = useWindowSize();
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        if (showModalOnFirstLoad()) {
            setShowModal(true);
        }
        else {
            props.onClose();
        }
    }, []);

    useEffect(() => {

        if (showModal) {
            window.addEventListener('scroll', handleScroll);
            window.addEventListener('touchmove', handleScroll);
            document.addEventListener('mousedown', handleClick);
        }

        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('touchmove', handleScroll);
            document.removeEventListener('mousedown', handleClick);
        };

    }, [showModal]);

    const showModalOnFirstLoad = () => {
        const lastClosed = localStorage.getItem(LoginPromptEvents.signInForBestExperience.Text);
        const lastPromptClosed = localStorage.getItem(LoginPromptEvents.loginPromptLastClosed.Text);
        const now = new Date();
        if (getURLParameter(window.location.href, 'sam') || getURLParameter(window.location.href, 'samw') || getURLParameter(window.location.href, 'mao') || getURLParameter(window.location.href, 'lpe') || getURLParameter(window.location.href, 'tsu')) {
            return false;
        }
        else if (lastPromptClosed && Math.floor((now - new Date(lastPromptClosed)) / (1000 * 60 * 60 * 24)) <= 1) {
            return false;
        }

        if (lastClosed) {
            const lastClosedDate = new Date(lastClosed);
            const diff = Math.floor((now - lastClosedDate) / (1000 * 60 * 60 * 24));

            if (diff >= 7) {
                localStorage.setItem(LoginPromptEvents.signInForBestExperience.Text, now);
                localStorage.setItem(LoginPromptEvents.loginPromptLastClosed.Text, now);
                    return true;
            }
            return false;
        }
        else {
            localStorage.setItem(LoginPromptEvents.signInForBestExperience.Text, now);
            localStorage.setItem(LoginPromptEvents.loginPromptLastClosed.Text, now);
            return true;
        }
    };

    const handleScroll = () => {
        const scrollPosition = window.scrollY;

        if (scrollPosition > 100) {
            handleClose();
        }

        let distanceFromTop = windowSize.isMobile ? 65 : 34;
        const header = document.getElementsByClassName('site-header')?.[0];
        const modal = document.getElementsByClassName('signin-bestexperience-modal')?.[0];
        const modalBody = document.getElementsByClassName('ts-modal-content')?.[0];
        const arrow = document.getElementsByClassName('fa-caret-up')?.[0];
        const appBanner = document.getElementsByClassName('app-banner')?.[0];
        const popUp = document.getElementsByClassName('DoubleClick_Top_PopUp')?.[0];
        const popUpHiddenDiv = document.getElementsByClassName('DoubleClick_Top_PopUp hidden')?.[0];
        const popUpHidden = popUp ? (popUp.style.visibility === 'hidden' || popUpHiddenDiv) : true;

        if (appBanner) {
            distanceFromTop += appBanner.getBoundingClientRect().height;
        }

        if (!props.mobileApp && popUpHidden && !header.getBoundingClientRect().bottom <= 0) {
            if (modal && modalBody) {
                if (!windowSize.isMobile) {
                    if (scrollPosition > 0) {
                        arrow.style.display = 'none';
                    }
                    else {
                        arrow.style.display = 'block';
                    }
                }
                if (distanceFromTop - scrollPosition >= 0) {
                    modal.style.top = `${distanceFromTop - scrollPosition}px`;
                }
                else {
                    modal.style.top = '0px';
                }

                modalBody.style.top = `${scrollPosition}px`;

                if (windowSize.isMobile && scrollPosition < 10) {
                    modalBody.style.top = '10px';
                }

                if (scrollPosition > distanceFromTop) {
                    modalBody.style.top = `${distanceFromTop}px`;
                }
            }
        }
        if (!popUpHidden) {
            if (modal && modalBody) {
                const topRow = document.getElementsByClassName('top-row-content')?.[0];
                const middleRow = document.getElementsByClassName('middle-row')?.[0];
                const bottomRow = document.getElementsByClassName('bottom-row')?.[0];
                if (topRow) {
                    topRow.style.zIndex = 'unset';
                }
                if (middleRow) {
                    middleRow.style.zIndex = 'unset';
                    if (appBanner) {
                        appBanner.style.zIndex = 'unset';
                    }
                }
                if (bottomRow) {
                    bottomRow.style.zIndex = 'unset';
                }
                modal.style.zIndex = '1504';
                modal.style.top = '165px';
                modalBody.style.top = '10px';
            }
        }
    };

    const handleClick = (event) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
            handleClose();
        }
    };

    const handleClose = () => {
        props.onClose();
        setLocalStorageValue(LoginPromptEvents.signInForBestExperience.Text, new Date());
    };

    return (
        showModal ? (
            <>
                {showModal && !windowSize.isMobile && !props.mobileApp &&
                    < i className={'fas fa-caret-up' + (currentSite?.Site?.IsBidcaller ? ' is-ef' : '')} />
                }
                {showModal &&
                    <div className='modalContainer' ref={modalRef}>
                        <Modal containerClassName={'signin-bestexperience-modal' + (props.mobileApp ? ' app' : '') + (document.getElementsByClassName('app-banner')?.[0] ? ' mobile-banner' : '')} alterFocus={true} allowScroll={true} onEscapeKeyClose={handleClose} >
                            <Modal.Header onClose={handleClose}>{translator.translate('sandhills.tradesites.mvc.signinforthebestexperience')} </Modal.Header>
                            <Modal.Body>
                                <input
                                    type='button'
                                    id={'sign-in-modal-button'}
                                    className='signin-bestexperience-btn button ts-button'
                                    value={translator.translate('sandhills.tradesites.mvc.signin')}
                                    onClick={() => {
                                        window.location.href = routes.SSO;
                                    }}
                                />
                                <p>
                                    {translator.translate('sandhills.tradepubwebsite.mvc.donthaveanaccount')}
                                    <a href={routes.Register} id={'sign-in-modal-register-button'}>{translator.translate('sandhills.tradepubwebsite.mvc.registerhere')}</a>
                                </p>
                            </Modal.Body>
                        </Modal>
                    </div>
                }
            </>
        ) : null
    );
};

export default SignInForBestExperienceModal;
